<template>
  <div class="pc_properties-wrapper">
    <div
      :class="[item.selected || item.showAnswers ? 'property-list' : '']"
      v-for="(item, propertyIndex) in properties"
      :key="item.question"
    >
      <transition name="list">
        <div v-if="item.selected || item.showAnswers">
          <!-- 单选 -->
          <div v-if="multiSelectId != item.id">
            <div class="property-header" ref="item">
              <div class="title">
                <img
                  v-if="item.showAnswers"
                  style="width: 20px; height: 20px; margin-right: 12px"
                  :src="DownSelect"
                  alt=""
                />
                <img
                  v-else
                  style="width: 20px; height: 20px; margin-right: 12px"
                  :src="UpSelect"
                  alt=""
                />
                <span>{{ propertyIndex + 1 }}. {{ item.question }}</span>
                <el-popover placement="bottom" width="394" height="326" trigger="hover">
                  <div>
                    <el-carousel
                      :autoplay="false"
                      width="370px"
                      height="230px"
                      v-if="item.specImageList"
                    >
                      <el-carousel-item v-for="imgItem in item.specImageList" :key="imgItem">
                        <img :src="imgItem" alt="" />
                      </el-carousel-item>
                    </el-carousel>
                    <div>{{ item.specDesc }}</div>
                  </div>
                  <img
                    slot="reference"
                    class="icon-what"
                    :src="IconQuestion"
                    v-if="item.specDesc || (item.specImageList && item.specImageList.length > 0)"
                    @click.stop="showDescUppop(item, propertyIndex + 1)"
                  />
                  <!--                  <img slot="reference" class="icon-what" src="@/assets/icon/icon-what@2x.png" v-if="item.specDesc || (item.specImageList && item.specImageList.length>0)"/>-->
                </el-popover>
              </div>
              <span class="selected">{{ item.selected.optionName }}</span>
              <div class="edit" @click="showAnswers(propertyIndex)" v-if="item.selected">
                <img src="@/assets/icon/icon-edit.png" />
              </div>
            </div>

            <!--答案项列表（单选）-->
            <transition name="slide-fade">
              <ul class="answers-wrapper" v-show="item.showAnswers">
                <item-err-tip :txt="item.specHint"></item-err-tip>
                <template v-for="answer in item.optionList">
                  <li
                    :key="answer.id"
                    v-if="!hideAnswer(item, answer.id)"
                    class="answer_li"
                    :class="[
                      {
                        active: item.selected.id === answer.id,
                        disable:
                          canNotOpenOptions.indexOf(answer.id) !== -1 &&
                          item.keyName == 'standardSpecificationList'
                      }
                    ]"
                    @click="selectAnswer(propertyIndex, answer, item.keyName)"
                  >
                    <p class="name">
                      {{ answer.optionName }}
                    </p>
                    <!--                    <div class="box-anserImg" v-if="answer.answerDesc || (answer.answerImageList && answer.answerImageList.length>0)" @click.stop="showDescUppop(item, propertyIndex + 1, answer)">-->
                    <!--                      <img-->
                    <!--                        v-if="answer.answerImageList && answer.answerImageList.length>0"-->
                    <!--                        class="img-anserImg"-->
                    <!--                        fit="cover"-->
                    <!--                        :src="answer.answerImageList[0]"-->
                    <!--                      />-->
                    <!--                      <img class="img-anserImg" v-else src="@/assets/img/img-default-phone.png"/>-->
                    <!--                      <img class="img-enlarge" src="@/assets/icon/icon-enlarge@2x.png"/>-->
                    <!--                    </div>-->
                    <div
                      class="box-anserImg"
                      v-if="
                        answer.answerDesc ||
                        (answer.answerImageList && answer.answerImageList.length > 0)
                      "
                    >
                      <el-popover placement="bottom" width="394" height="326" trigger="hover">
                        <div>
                          <el-carousel
                            :autoplay="false"
                            width="370px"
                            height="230px"
                            v-if="answer.answerImageList"
                          >
                            <el-carousel-item
                              v-for="imgItem in answer.answerImageList"
                              :key="imgItem"
                            >
                              <img :src="imgItem" alt="" />
                            </el-carousel-item>
                          </el-carousel>
                          <div>{{ answer.answerDesc }}</div>
                        </div>
                        <img
                          slot="reference"
                          @click.stop
                          class="icon-what"
                          src="@/assets/icon/icon-what@2x.png"
                          v-if="
                            answer.answerDesc ||
                            (answer.answerImageList && answer.answerImageList.length > 0)
                          "
                        />
                      </el-popover>
                    </div>
                  </li>
                </template>
                <!-- 苹果机的型号和购买渠道显示对应操作图 -->
                <!-- 型号 -->
                <!--文本为：型号-->
                <div class="guide-wrapper" v-if="brandId === 2 && item.question === 'Model'">
                  <!--文本为：您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号-->
                  <!-- <p class="entrance">
                        Bạn có thể tìm trong điện thoại
                        <span>"Cài đặt"-"Cài đặt chung"-"Pháp lý và quy định"</span>Tìm được model。
                      </p> -->
                  <p class="entrance">{{ $t('model.answerTip01') }}</p>
                  <img :src="require(`@/assets/image/${$img}/xinghao.png`)" alt="" />
                </div>
                <!-- 购买渠道 -->
                <div class="guide-wrapper" v-if="brandId === 2 && item.question === '购买渠道'">
                  <!--文本为：您可在手机的 | 【设置】-【通用】-【监管】 | 找到型号-->
                  <!-- <p class="entrance">
                        Bạn có thể tìm trong điện thoại
                        <span>"Cài đặt"-"Cài đặt chung"-"Pháp lý và quy định"</span>Tìm được model。
                      </p> -->
                  <p class="entrance">{{ $t('model.answerTip01') }}</p>
                  <img :src="require(`@/assets/image/${$img}/goumaiqudao.png`)" alt="" />
                  <p>
                    <!--文本为：N开头是官换机；F开头是官翻机/官修机；3开头是 展示机；-->
                    <span class="order">1</span>{{ $t('model.answerTip02') }}
                  </p>
                  <!-- <p>
                        <span class="order">2</span
                        >gồm CH là máy cho thị trường Trung Quốc, ZP là thị trường Hong Kong, không thuộc CH/ZP thì là hàng xách tay
                      </p> -->
                  <p><span class="order">2</span>{{ $t('model.answerTip05') }}</p>
                  <!--文本为：有锁无锁？-->
                  <p class="title">{{ $t('model.answerTip03') }}</p>
                  <!--文本为： 插上其他卡看是否能正常通话辨别有无锁，有锁一般
                        需要激活，无法正常通话。-->
                  <p>
                    {{ $t('model.answerTip04') }}
                  </p>
                </div>
              </ul>
            </transition>
          </div>
          <!-- 多选 -->
          <div v-if="multiSelectId == item.id && isAllSelected">
            <div class="property-header border-top-1px">
              <!--文本为：可选可不选-->
              <!-- <span class="title"
                      >{{ properties ? properties.length : ''}}.
                      {{ `${item.question} (${$t('other.chooseOrNot')})` }}</span
                    > -->
              <div class="title">
                <img
                  v-if="item.showAnswers"
                  style="width: 20px; height: 20px; margin-right: 12px"
                  :src="DownSelect"
                  alt=""
                />
                <img
                  v-else
                  style="width: 20px; height: 20px; margin-right: 12px"
                  :src="UpSelect"
                  alt=""
                />
                <span
                  >{{ properties ? properties.length : '' }}.{{
                    `${item.question} (${$t('other.chooseOrNot')})`
                  }}</span
                >
                <img
                  class="icon-what"
                  src="@/assets/icon/icon-what@2x.png"
                  v-if="item.specDesc || (item.specImageList && item.specImageList.length > 0)"
                  @click.stop="showDescUppop(item, properties ? properties.length : '')"
                />
              </div>
            </div>

            <!--功能性答案项列表（可多选）-->
            <transition name="slide-fade">
              <ul class="answers-wrapper" :class="[{ show: item.showAnswers }, 'clearfix']">
                <item-err-tip :txt="item.specHint"></item-err-tip>
                <template v-for="answer in item.optionList">
                  <li
                    :key="answer.id"
                    v-if="!hideAnswer(item, answer.id)"
                    class="answer_li"
                    :class="[
                      {
                        active: item.selected.includes(answer.optionName),
                        disable:
                          canNotOpenOptions.indexOf(answer.id) !== -1 &&
                          item.keyName == 'standardSpecificationList'
                      },
                      'fl'
                    ]"
                    @click="
                      multiSelectAnswer(propertyIndex, answer.optionName, answer.id, item.keyName)
                    "
                  >
                    <span class="name">{{ answer.optionName }}</span>
                    <el-popover placement="bottom" width="394" height="326" trigger="hover">
                      <div>
                        <el-carousel
                          :autoplay="false"
                          width="370px"
                          height="230px"
                          v-if="answer.answerImageList"
                        >
                          <el-carousel-item
                            v-for="imgItem in answer.answerImageList"
                            :key="imgItem"
                          >
                            <img :src="imgItem" alt="" />
                          </el-carousel-item>
                        </el-carousel>
                        <div>{{ answer.answerDesc }}</div>
                      </div>
                      <img
                        slot="reference"
                        @click.stop
                        style="width: 20px; height: 20px"
                        src="@/assets/icon/icon-what@2x.png"
                        v-if="
                          answer.answerDesc ||
                          (answer.answerImageList && answer.answerImageList.length > 0)
                        "
                        @click.stop="
                          showDescUppop(item, properties ? properties.length : '', answer)
                        "
                      />
                      <!--                          <img slot="reference" @click.stop class="icon-what" src="@/assets/icon/icon-what@2x.png" v-if="answer.answerDesc || (answer.answerImageList && answer.answerImageList.length>0)"/>-->
                    </el-popover>
                  </li>
                </template>
              </ul>
            </transition>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="properties.length > 0 && current >= properties.length" class="property-list">
      <transition name="list">
        <!-- imei -->
        <div>
          <div class="property-header" ref="item">
            <div class="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 12px"
                  :src="UpSelect"
                  alt=""
                />
              <span>{{ properties.length + 1 }}. IMEI del dispositivo antiguo</span>
            </div>
          </div>
          <!--答案项列表（单选）-->
          <transition name="slide-fade">
            <div class="answers-wrapper">
              <div class="input-content">
                <el-input
                  type="text"
                  class="imei-input"
                  :placeholder="$t('PCPropertyList.index.646ynp3uehw0')"
                  v-model="imei"
                  maxlength="15"
                  show-word-limit
                  @input="changeInput"
                ></el-input>
                <!-- <div class="number">{{ imei ? imei.length : 0 }}/15</div> -->
                <div class="imei-tip">{{ $t('PCPropertyList.index.646ynp3uem40') }}</div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div>


    <!-- <div v-if="properties.length > 0 && current >= properties.length + 1" class="property-list">
      <transition name="list">
        <div>
          <div class="property-header" ref="item">
            <div class="title">
                <img
                  style="width: 20px; height: 20px; margin-right: 12px"
                  :src="UpSelect"
                  alt=""
                />
              <span>{{ properties.length + 2 }}. Promotion code</span>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="answers-wrapper">
              <div class="input-content">
                <el-input
                  type="text"
                  class="imei-input"
                  v-model="qrcode"
                  maxlength="6"
                  show-word-limit
                  @input="qrcodeVerify"
                ></el-input>
                <div></div> 
                <div class="imei-tip" v-if="showErrorCode" style="color: #EE0A24"> {{ $t('component.tradeInProcess.invalidCode') }}</div>
                <div class="imei-tip">Enter the promo code to get extra discounts.</div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div> -->
    <!-- 不回收此类机型 我知道了 -->
    <el-dialog :title="$t('successOrder.successOrder.tips')" center width="30%" :visible.sync="show_notChoose">
      <span style="text-align: center">{{ $t('successOrder.successOrder.notRecyclable') }}</span>
      <div slot="footer" class="btn-footer">
        <div class="btn-div" @click="show_notChoose = false">{{ $t('successOrder.successOrder.IKnow') }}</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import QuestionPupup from '../question-pupup.vue';
import itemErrTip from '../item-err-tip.vue';
import formatProperties from '@/utils/device';
// import DescPopup from "@/views/choose-device-properties/childComp/descPopup/DescPopup.vue"

import PCPopoverInfo from '../PCPopoverInfo';

import DownSelect from '@/assets/PC/icons/down-select@2x.png';
import UpSelect from '@/assets/PC/icons/up-select@2x.png';
import IconQuestion from '@/assets/PC/icons/icon-question@2x.png';
import IconHover from '@/assets/PC/icons/icon-question-hover@2x.png';

import {
  checkQrCode
} from '@/services/api/product';

export default {
  // props: ["data", "brandId", "multiSelectId", "canNotOpenOptions"],
  props: {
    current: 0,
    data: {},
    brandId: {},
    multiSelectId: {},
    canNotOpenOptions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      questionData: {
        title: '',
        url: '',
        content: ''
      },
      show_notChoose: false,

      isTgddAgent: JSON.parse(window.localStorage.getItem('dhUserInfo'))?.tgdd ? true : false,
      DownSelect,
      UpSelect,
      IconQuestion,
      IconHover,
      imei: '',
      qrcode: this.$route.query.qrcode || '',
      showErrorCode: false
    };
  },
  computed: {
    properties() {
      console.log('data', this.data, 'brandId', this.brandId);
      console.log('formatProperties', formatProperties(this.data, this.brandId));
      // console.log("数据", this.data, this.brandId);//keyName: "standardSpecificationList"
      return formatProperties(this.data, this.brandId);
    },
    /**
     * 判断前面的答案项是否全勾选
     */
    isAllSelected() {
      let propertiesExcludeLastOne = JSON.parse(JSON.stringify(this.properties));
      propertiesExcludeLastOne.pop();
      let isAllSelected = propertiesExcludeLastOne.every(item => {
        return item.selected;
      });
      console.log('isAllSelected', isAllSelected);
      return isAllSelected;
    }
  },
  created(){
    console.log(123456)
    this.qrcodeVerify(this.$route.query.qrcode)
  },
  components: {
    QuestionPupup,
    itemErrTip,
    // DescPopup,
    PCPopoverInfo
  },
  methods: {
    test() {
      console.log(this.properties);
    },

    qrcodeVerify(code) {
      if (code && code.length == 6) {
        checkQrCode({
          qrCode: code,
          channelId: 100000,
          nation: 'ES'
        })
          .then((res) => {
            if(res.code == '0000'){
              console.log("code",res.data)
              this.showErrorCode = !res.data
              if(res.data){
                console.log("true",res.data)
                this.$emit("changeQrcode",code)
              }else{
                this.$emit("changeQrcode",'')
              }
            }
          })
          .catch(err => {
          });
      }else{
        this.showErrorCode = false
        this.$emit("changeQrcode",'')
      }
    },
    /**
     * 显示问号弹窗
     */
    showQuestionPopup(answer) {
      this.questionData.title = answer.name;
      this.questionData.url = answer.specImageShow;
      this.questionData.content = answer.specContent;
      this.$refs.question.show();
    },
    /**
     * 显示答案项列表
     * @param propertyIndex
     */
    showAnswers(propertyIndex) {
      this.$emit('showAnswers', propertyIndex);
    },
    /**
     * 选择答案（单选）
     * @param propertyIndex
     * @param answer
     */
    selectAnswer(propertyIndex, answer, keyName) {
      if (
        this.canNotOpenOptions.indexOf(answer.id) !== -1 &&
        keyName == 'standardSpecificationList'
      ) {
        this.show_notChoose = true;
        return;
      }
      const data = {
        propertyIndex,
        answer
      };
      this.$emit('selectAnswer', propertyIndex, answer);
    },
    /**
     * 功能性问题选择答案（可多选或不选）
     * @param propertyIndex
     * @param name
     */
    multiSelectAnswer(propertyIndex, name, id, keyName) {
      if (this.canNotOpenOptions.indexOf(id) !== -1 && keyName == 'standardSpecificationList') {
        this.show_notChoose = true;
        return;
      }
      const data = {
        propertyIndex,
        name
      };
      this.$emit('multiSelectAnswer', propertyIndex, name);
    },
    // 字符串截取
    stringSplice(str) {
      if (str.length > 10) {
        return str.slice(0, 10) + '...';
      }
      return str;
    },
    hideAnswer(item, answerID) {
      if (
        this.isTgddAgent &&
        item.keyName === 'standardSpecificationList' &&
        (answerID === 20 || answerID === 21)
      ) {
        return true;
      }
      return false;
    },
    // 显示问题/答案详情弹窗
    showDescUppop(question, index, answer) {
      let obj = {
        question,
        indexNum: index,
        answer
      };

      // this.$refs?.descPopup?.show(obj)
    },
    changeInput(val){
      this.$emit('changeCurrent', val)
    }
  }
};
</script>

<style lang="less" scoped>
// @import "../../../../styles/reset.scss";
.pc_properties-wrapper {
  box-sizing: border-box;
  padding: 12px;

  .active {
    // border-color: var(--theme-color) !important;
    border-color: #405FFF !important;
    color: var(--theme-color) !important;
    background: #ffffff !important;
    color: #405FFF;
  }
  .disable {
    // background: #F2F3F5 !important;
    // border: none !important;
    color: #c4c7cc !important;
  }

  .property-list {
    background: #f8f8f8;
    margin-bottom: 16px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 16px;
    color: #282828;
    padding: 0 16px;
    .property-header {
      min-height: 56px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        font-weight: 500;
        .icon-what {
          width: 20px;
          height: 20px;
          //margin-left: 7px;
          //margin-right: 25px;
          box-sizing: border-box;
          //padding: 8px 0;
          margin-top: 2px;
          margin-left: 12px;
        }
      }
      .selected {
        flex: 1;
        text-align: right;
        //padding-right: 25px;
        font-weight: 400;
        color: #6e6e6e;
        display: -webkit-box; /** 将对象作为伸缩盒子模型显示 **/
        -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
        -webkit-line-clamp: 2; /** 显示的行数，显示高度设置成行高，多余部分隐藏 **/
        overflow: hidden; /**超出部分隐藏 **/
      }
      .edit {
        color: #6e6e6e;
        display: flex;
        align-items: center;
        i {
          @include bg('../../../../assets/edit');
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 4px;
        }
      }
    }
    .answers-wrapper {
      //margin: 5px 0 5px 0;
      //padding: 0 20px;
      word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      li {
        height: 60px;
        flex: 1;
        width: calc((100% - 12px) / 2);
        min-width: calc((100% - 12px) / 2);
        max-width: calc((100% - 12px) / 2);
        padding: 0 12px;
        font-size: 15px;
        border-radius: 4px;
        // color: $lightBlack;
        margin-right: 12px;
        margin-bottom: 12px;
        background: #fff;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        .name {
          display: flex;
          align-items: center;
          .i-question {
            width: 15px;
            min-width: 15px;
            -webkit-box-orient: vertical;
            height: 15px;
            background: #ccc;
            // color: $white;
            font-size: 12px;
            border-radius: 50%;
            text-align: center;
            line-height: 15px;
            margin-right: 11px;
          }
        }
        .desc {
          // color: $gray;
          font-size: 13px;
          margin-top: 5px;
        }
      }
      li:nth-child(2n) {
        /* 去除第2个的margin-right */
        margin-right: 0;
      }
      .guide-wrapper {
        background: #f4f5f8;
        border-radius: 5px;
        margin-top: 30px;
        padding: 16px;
        font-size: 12px;
        // color: $black;
        .entrance {
          // color: $gray;
          span {
            // color: $black;
            font-weight: 600;
          }
        }
        p {
          font-size: 12px;
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
          }
          .order {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #415fff;
            // color: $white;
            line-height: 16px;
            text-align: center;
            margin-right: 8px;
          }
        }
        .title {
          font-size: 13px;
          font-weight: 600;
        }
        img {
          width: 100%;
          height: 106px;
          margin-bottom: 17px;
          border-radius: 5px;
        }
      }
      .answer_li:hover{
        border:1px solid #405FFF;
        color: #405FFF;
      }
      .answer_li {
        display: flex;
        align-items: center;
        height: 60px;
        .name {
          flex: 1;
        }
        .icon-what {
          width: 20px;
          height: 20px;
          box-sizing: border-box;
          margin-top: 23px;
          //margin-left: 12px;
        }
        .imgBox {
          width: 50px;
          height: 50px;
          background: pink;
        }
        .box-anserImg {
          width: 60px;
          height: 60px;
          line-height: 60px;
          text-align: right;
          position: relative;
          border-radius: 6px;
          .img-anserImg {
            width: 60px;
            height: 60px;
            border-radius: 6px;
          }
          .img-enlarge {
            width: 18px;
            height: 18px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
      }

      .imei-tip {
        color: var(--text-3, #8f949d);
        font-family: 'PingFang SC';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 8px 0 16px 0;
      }

      .imei-input {
        width: 320px;
      }

      /deep/ .el-popover__reference-wrapper {
        height: 20px;
        width: 20px;
        margin-left: 12px !important;
      }
    }
  }
  /deep/ .box-anserImg {
    img {
      border-radius: 6px;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0;
    text-align: center;
    height: 40px;
    color: #6e6e6e;
  }

  .btn-div {
    width: 88px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    background-color: #405FFF;
    color: #fff;
    font-size: 14px;
  }
  .btn-footer {
    display: flex;
    justify-content: center;
  }
  /deep/ .el-dialog__header {
    height: 0;
    padding-top: 24px;
    padding-bottom: 30px;
  }
  /deep/ .el-dialog__title {
    color: #282828;
    font-size: 24px;
    font-weight: 500;
  }
  /deep/ .el-dialog__headerbtn:hover {
    color: #405FFF;
  }
  /deep/.el-dialog__headerbtn:focus .el-dialog__close,
  /deep/.el-dialog__headerbtn:hover .el-dialog__close {
    color: #405FFF;
  }
  /deep/.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
